<template>
  <div class="chaton-empty-conversation">
    <i :class="listIcon"></i>
    <span v-if="isSidebarProps">{{TRANS.no_results}}</span>
    <span v-else>{{TRANS.start_conversation}}</span>
  </div>
</template>

<script>
  export default {
    name : "EmptyView",
    props:['isSidebarProps', 'listIcon'],
  }
</script>
 
<style>
.chaton-empty-conversation {
    text-align: center;
    background-color: transparent;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    top: -50px;
    position: relative;
}
.chaton-empty-conversation i {
  color: var(--themewhatsappcolor);
  font-size: 32px;
  display: block;
  margin-bottom: 10px;
}
.chaton-empty-conversation span {
  color: var(--terwhatsappcolor);
  display: block;
  font: 500 20px/30px var(--primchatfont);
}
</style>